export default "__VITE_ASSET__DMhTNJsm__"